export const assistBarLongException = (state) => {
    if (state.sidePanel === "With Side Panels") {
        return "Not available with side panel";
    }
    return null;
};
